import nProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { useMutationObserver } from '@vueuse/core';

export const useNProgress = (options?: Partial<nProgress.NProgressOptions>) => {
  if (options) {
    nProgress.configure(options);
  }
  const start = () => {
    nProgress.start();
  };
  const set = (num: number) => {
    nProgress.set(num);
  };
  const done = () => {
    nProgress.done();
  };
  return { start, set, done };
};

export const useRem = () => {
  const html = document.querySelector('html');
  if (!html) {
    return ref(0);
  }
  const rootRem = ref(Number(html.style.fontSize.replace('px', '')));
  useMutationObserver(
    html,
    (mutations) => {
      const styleAttribute = mutations.find((item) => item.attributeName === 'style');
      if (styleAttribute && styleAttribute.attributeName === 'style') {
        rootRem.value = Number(html.style.fontSize.replace('px', ''));
      }
    },
    { attributeFilter: ['style'], attributes: true },
  );
  return rootRem;
};
